import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1692.48,910.647059 L959.717647,1598.00706 L228.536471,912.228235 C73.92,755.352941 73.92,500.105882 228.536471,343.230588 C303.077647,267.672941 402.24,225.997647 507.84,225.997647 L507.952941,225.997647 C613.44,225.997647 712.602353,267.672941 787.030588,343.230588 L787.143529,343.343529 C861.910588,419.127059 903.247059,520.209412 903.247059,627.729412 L1016.18824,627.729412 C1016.18824,520.209412 1057.41176,419.127059 1132.29176,343.230588 C1206.72,267.672941 1305.88235,225.997647 1411.48235,225.997647 L1411.59529,225.997647 C1517.08235,225.997647 1616.35765,267.672941 1690.78588,343.230588 C1845.40235,500.105882 1845.40235,755.352941 1692.48,910.647059 M1771.31294,263.945882 C1675.42588,166.590588 1547.57647,113.056471 1411.59529,113.056471 L1411.48235,113.056471 C1275.38824,113.056471 1147.65176,166.590588 1051.87765,263.832941 C1014.26824,301.894118 983.435294,344.811765 959.717647,391.230588 C936,344.811765 905.054118,301.894118 867.557647,263.945882 C771.783529,166.590588 644.047059,113.056471 507.952941,113.056471 L507.84,113.056471 C371.858824,113.056471 244.009412,166.590588 148.009412,263.945882 C-49.6376471,464.642353 -49.6376471,790.929412 149.703529,992.981176 L959.717647,1752.84941 L1771.31294,991.4 C1968.96,790.929412 1968.96,464.642353 1771.31294,263.945882",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconHeartLine = /*#__PURE__*/function (_Component) {
  _inherits(IconHeartLine, _Component);

  var _super = _createSuper(IconHeartLine);

  function IconHeartLine() {
    _classCallCheck(this, IconHeartLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconHeartLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconHeart",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconHeartLine.displayName = "IconHeartLine";
  return IconHeartLine;
}(Component);

IconHeartLine.glyphName = 'heart';
IconHeartLine.variant = 'Line';
IconHeartLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconHeartLine;
export { IconHeartLine };